<template>
  <el-form ref="form"
           class="action-form"
           v-bind="$extend($props, $attrs)">
    <template v-if="actionParams">
      <template v-for="(value, key) in actionParams">
        <template v-if="Array.isArray(value)">
          <input v-for="(val, index) in value"
                 :key="'action-param-' + key + '-' + index"
                 type="hidden"
                 :name="key"
                 :value="val"/>
        </template>
        <input v-else
               :key="'action-param-' + key"
               type="hidden"
               :name="key"
               :value="value"/>
      </template>
    </template>
    <slot :submit="submit"></slot>
  </el-form>
</template>

<script>
export default {
  name: 'ActionForm',
  props: {
    action: String,
    method: String,
    target: String,
    preHandleParams: Function,
    formParams: Object,
    params: [Object, Array]
  },
  data () {
    return {
      actionParams: null
    }
  },
  methods: {
    submit (callback) {
      let form = this.$refs.form
      if (form) {
        if (this.action && this.action.startsWith('/')) {
          this.$store.dispatch('globalActionParams', this.action).then(params => {
            this.actionParams = this.$extend(
              this.preHandleParams ? this.preHandleParams() : {},
              this.formParams,
              this.params,
              params)
            this.$nextTick(() => {
              form.$el.submit()
              if (typeof callback === 'function') {
                callback()
              }
            })
          }).catch(err => {
            if (typeof callback === 'function') {
              callback()
            }
            this.$message({
              message: err.message,
              type: 'warning',
              center: true
            })
          })
        } else {
          form.$el.submit()
          if (typeof callback === 'function') {
            callback()
          }
        }
      } else {
        if (typeof callback === 'function') {
          callback()
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .action-form {
    margin: 0;
    padding: 0;
    &:before,
    &:after {
      display: none!important;
    }
  }
</style>
